// Phase I3 — Market Category Selector.
// 5 toggles (ALL / OUTCOME / DISCIPLINE / TERRITORY / PLAYER); the active
// id is lifted up via `onChange` so the page can swap in the matching DNA
// panel below. Faithful port of prototype/super-acca-v2.jsx.

import { CATEGORY, type CategoryId } from "../../../super-acca/categories";
import { Eyebrow } from "../../../components/super-acca";

export type MarketCategoryFilter = "ALL" | CategoryId;

export interface MarketCategorySelectorProps {
  active: MarketCategoryFilter;
  onChange: (next: MarketCategoryFilter) => void;
}

interface CatItem {
  id: MarketCategoryFilter;
  label: string;
  color: string;
  glyph: string;
}

const CATS: CatItem[] = [
  { id: "ALL", label: "ALL", color: "var(--sa-fg-primary)", glyph: "◉" },
  {
    id: "OUTCOME",
    label: CATEGORY.OUTCOME.label,
    color: CATEGORY.OUTCOME.color,
    glyph: CATEGORY.OUTCOME.glyph,
  },
  {
    id: "DISCIPLINE",
    label: CATEGORY.DISCIPLINE.label,
    color: CATEGORY.DISCIPLINE.color,
    glyph: CATEGORY.DISCIPLINE.glyph,
  },
  {
    id: "TERRITORY",
    label: CATEGORY.TERRITORY.label,
    color: CATEGORY.TERRITORY.color,
    glyph: CATEGORY.TERRITORY.glyph,
  },
  {
    id: "PLAYER",
    label: CATEGORY.PLAYER.label,
    color: CATEGORY.PLAYER.color,
    glyph: CATEGORY.PLAYER.glyph,
  },
];

export function MarketCategorySelector({ active, onChange }: MarketCategorySelectorProps) {
  return (
    <div style={{ marginTop: 28 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        <Eyebrow>Market Category Intelligence</Eyebrow>
        <span
          style={{
            fontFamily: "var(--sa-font-mono)",
            fontSize: 10.5,
            color: "var(--sa-fg-muted)",
            letterSpacing: "0.16em",
          }}
        >
          SAME FIXTURE · LIVE
        </span>
      </div>
      <div style={{ display: "flex", gap: 8, marginTop: 14, flexWrap: "wrap" }}>
        {CATS.map((c) => {
          const isActive = c.id === active;
          return (
            <button
              key={c.id}
              type="button"
              onClick={() => onChange(c.id)}
              style={{
                background: isActive ? `${c.color}15` : "var(--sa-bg-panel)",
                color: isActive ? c.color : "var(--sa-fg-secondary)",
                border: `1px solid ${isActive ? c.color : "var(--sa-hairline)"}`,
                padding: "10px 16px",
                borderRadius: 4,
                fontFamily: "var(--sa-font-mono)",
                fontSize: 11,
                letterSpacing: "0.16em",
                textTransform: "uppercase",
                cursor: "pointer",
                display: "flex",
                gap: 8,
                alignItems: "center",
                transition: "all .15s",
              }}
            >
              <span aria-hidden>{c.glyph}</span>
              {c.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
